<div class="profile__wrapper" *ngIf="isLoaded">
  <div class="bank" *ngIf="idOfPE; else donthavePE">
    <form [formGroup]="bankInfoForm">
      <div class="row">
        <div class="col-6" *ngIf="!hasAnyBankInfo">
          The employee doesn't have any bank info yet
        </div>
        <div class="col-6" *ngIf="hasAnyBankInfo">
          <div class="row mb-3 profile__item">
            <label class="label-input col-sm-3">Bank name</label>
            <div class="col-sm-3">
              <app-dropdown
                [border]="isEditable ? 'classic' : 'none'"
                formControlName="bankName"
                [items]="availableBanksDropdown"
              ></app-dropdown>
            </div>
          </div>
          <fieldset [disabled]="!isEditable" class="form__fieldset">
            <div class="row mb-3 profile__item">
              <label class="label-input col-sm-3">USD IBAN </label>
              <div class="col-sm-3 profile__validation">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="usdiban"
                />
              </div>
            </div>
          </fieldset>
          <fieldset [disabled]="!isEditable" class="form__fieldset">
            <div class="row mb-3 profile__item">
              <label class="label-input col-sm-3">UAN IBAN </label>
              <div class="col-sm-3 profile__validation">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="uahiban"
                />
              </div>
            </div>
          </fieldset>
          <fieldset [disabled]="!isEditable" class="form__fieldset">
            <div class="row mb-3 profile__item">
              <label class="label-input col-sm-3">Bank SWIFT Code</label>
              <div class="col-sm-3 profile__validation">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="swiftCode"
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-6">
          <button
            type="button"
            class="button button__addIinterview"
            *ngIf="isEditable || (!hasAnyBankInfo && ableToEdit)"
            (click)="addNewBank()"
          >
            Add new bank
          </button>
        </div>
      </div>
      <fieldset [disabled]="!isEditable" class="form__fieldset">
        <div class="bank__tables" *ngIf="hasAnyBankInfo">
          <div
            class="bank__table"
            [class.bank__table-nodata]="cardsTableData.length === 0"
          >
            <div class="bank__table-desc">Card numbers</div>
            <app-table
              *ngIf="cardsTableData.length"
              [showEditFields]="isEditable"
              [tableType]="'material-plus'"
              [editMenu]="'icon'"
              [content]="cardsTableData"
              [headers]="cardsTableHeaders"
              (rowAction)="openCreditCards($event, cardsTableHeaders)"
            ></app-table>
            <button
              *ngIf="cardsTableData.length === 0 && isEditable"
              type="button"
              class="button button__add--normal table__btn"
              (click)="addTheFirstCard(cardsTableHeaders)"
            ></button>
          </div>
          <div
            class="bank__table"
            [class.bank__table-nodata]="autentificationTableData.length === 0"
          >
            <div class="bank__table-desc">Bank autentification credentials</div>
            <app-table
              *ngIf="autentificationTableData.length"
              [tableType]="'material-plus'"
              [editMenu]="'icon'"
              [content]="autentificationTableData"
              [headers]="autentificationTableHeaders"
              [showEditFields]="isEditable"
              (rowAction)="openCredentials($event, autentificationTableHeaders)"
            ></app-table>
            <button
              *ngIf="autentificationTableData.length === 0 && isEditable"
              type="button"
              class="button button__add--normal table__btn"
              (click)="addTheFirstCredential(autentificationTableHeaders)"
            ></button>
          </div>
          <div
            class="bank__table"
            [class.bank__table-nodata]="agreementTableData.length === 0"
          >
            <div class="bank__table-desc">Agreement info</div>
            <app-table
              *ngIf="agreementTableData.length"
              [tableType]="'material-plus'"
              [editMenu]="'icon'"
              [content]="agreementTableData"
              [headers]="agreementTableHeaders"
              [showEditFields]="isEditable"
              (rowAction)="openAgreement($event, agreementTableHeaders)"
            ></app-table>
            <button
              *ngIf="agreementTableData.length === 0 && isEditable"
              type="button"
              class="button button__add--normal table__btn"
              (click)="addTheFirstAgreement(agreementTableHeaders)"
            ></button>
          </div>
        </div>
      </fieldset>
    </form>
    <i
      class="icon-pencil"
      *ngIf="hasAnyBankInfo && ableToEdit"
      (click)="onEdit()"
      [class.grey]="isEditable"
    ></i>
    <button
      class="button button__save profile__button"
      *ngIf="isEditable"
      (click)="save()"
      #saveButton
    >
      Save
    </button>
  </div>
  <ng-template #donthavePE>
    Employee doesn't have PE yet. Please create it
  </ng-template>
</div>
